import { AES, enc } from "crypto-js";
import * as url from "../store/constant/Endpoints";
import icons from "helper/iconsHelper";
import { can_view_currencies } from "../helper/permissionsCheck";

let permissionUser = localStorage.getItem("data");

let decryptedData = null;
if (permissionUser) {
  try {
    decryptedData = AES.decrypt(permissionUser, url.encryptionSecret).toString(
      enc.Utf8
    );
  } catch (error) {
    console.log(error, "er");
  }
}

const currencies = can_view_currencies
  ? {
      id: "Currencies",
      title: "Currencies",
      icon: icons.currencies,
      type: "group",
      children: [
        {
          id: "all-currencies",
          title: "Currencies",
          type: "item",
          url: "/currencies/all-currencies",
          icon: icons.currencies,
          breadcrumbs: true,
        },
      ],
    }
  : null;

export default currencies;
